import opt from "@/assets/js/option";
import { Toast } from "vant";
import Vue from "vue";

export default {
  filterImg(value) {
    let url = process.env.VUE_APP_BASE_URL;
    if (value != undefined && value != null) {
      if (value.indexOf("http") != -1) {
        return value;
      }
    }
    return url + "/" + value;
  },
  maskPhone(phoneNumber) {
    if (!phoneNumber || phoneNumber.length !== 11) {
      return phoneNumber; // 如果号码为空或长度不正确，则直接返回原始值
    }
    // 使用正则表达式替换中间四位数字
    const maskedPhone = phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    return maskedPhone;
  },
  maskIdNumber(idNumber) {
    if (idNumber?.length !== 18) {
      return idNumber;
    }
    // 保留前6位和后4位，中间用星号代替
    return idNumber.slice(0, 6) + "************" + idNumber.slice(-4);
  },
  showLoading(txt) {
    Toast.loading({
      duration: 0, // 持续展示 toast
      forbidClick: true,
      message: txt,
    });
  },
  hideLoading() {
    Toast.clear();
  },
  toast(txt) {
    Toast(txt);
  },
  time2(stringTimestamp) {
    let date = new Date(stringTimestamp).getTime();
    return Vue.prototype.$utils.filterTimeFn(date, "YYYY-MM-DD");
  },
  filterTimeFn(stringTimestamp, format = "YYYY-MM-DD HH:mm:SS") {
    if (!stringTimestamp) return "";
    if ((stringTimestamp + "").length <= 10)
      stringTimestamp = stringTimestamp * 1000;
    let time = new Date(stringTimestamp);

    let Check = (obj) => {
      if (obj < 10) {
        return "0" + obj;
      }
      return obj;
    };
    let resFormat = format;
    let y = Check(time.getFullYear()); // 年
    let m = Check(time.getMonth() + 1); // 月
    let d = Check(time.getDate()); // 日
    let h = Check(time.getHours()); // 时
    let mm = Check(time.getMinutes()); // 分
    let ss = Check(time.getSeconds()); // 分

    // resFormat = resFormat.toUpperCase()
    resFormat = resFormat.replace(/YYYY/, y);
    resFormat = resFormat.replace(/MM/, m);
    resFormat = resFormat.replace(/DD/, d);
    resFormat = resFormat.replace(/HH/, h);
    resFormat = resFormat.replace(/mm/, mm);
    resFormat = resFormat.replace(/SS/, ss);

    return resFormat;
  },
  filterOpt(id, type) {
    if (id === null) {
      return "无";
    }

    if (id === "") {
      return "无";
    }
    console.log(id, 323);
    const options = opt[type];
    const find = options.find((item) => item.value == id);

    return find && find.text;
  },

  parkTimeFilter(val) {
    const year = parseInt(val / 1440);
    const hour = parseInt((val % 1440) / 60);
    const min = (val % 1440) % 60;
    return `${year}天${hour}小时${min}分`;
  },
  // 过滤数据
  filterNum(val, max) {
    if (val == undefined) {
      return 0;
    }
    if (max) {
      if (val > max) {
        return max;
      }
      return val;
    } else {
      if (val < 10000) {
        return val;
      } else if (val > 10000) {
        return `${(val / 10000).toFixed(1)}w`;
      }
    }
  },
  async downloadModel(path, fileName) {
    try {
      console.log(path, 22332);
      const response = await fetch(path);
      const blob = await response.blob();
      console.log(blob, 2323);
      // 从路径中获取文件名
      const name = path.substring(path.lastIndexOf("/") + 1);

      // 创建下载链接
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      // 使用原始文件名
      a.download = fileName || name;

      // 触发下载
      document.body.appendChild(a);
      a.click();

      // 清理
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      return true;
    } catch (error) {
      console.error("下载文件失败:", error);
      return false;
    }
  },
};
